export const USERNAME = "userName";
export const ALTERNATE_LOGIN_ID = "loginId";
export const FIRST_NAME = "firstName";
export const LAST_NAME = "lastName";
export const MOBILE_NO = "phoneNumber";
export const EMAIL_ID = "email";
export const ADDRESS = "address";
export const ADDRESS_1 = "addressLine1";
export const ADDRESS_2 = "addressLine2";
export const STATE = "state";
export const CITY = "city";
export const ZIPCODE = "zipCode";
export const PO_BOX = "pobox";
export const COUNTRY = "country";
export const DOB = "dob";
export const ORGANIZATION = "organization";

export const COMMUNITY = "employeeCommunitys";
export const COMMUNITY_NAME = "communityId";
export const ROLE = "role";
export const START_DATE = "startDate";
export const END_DATE = "endDate";

export const organizationOptions = [
  {
    label: "Hyderabad shared service",
    value: "HYDERABAD_SHARED_SERVICE",
  },
  { label: "GGCL Chicago", value: "GGCL_CHICAGO" },
  { label: "Others", value: "OTHERS" },
];

export const auditLog = [
  {
    date: "12-09-2025",
    action: "Employee Created",
  },
  {
    date: "12-09-2025",
    action: "Employee Created",
  },
  {
    date: "12-09-2025",
    action: "Employee Created",
  },
  {
    date: "12-09-2025",
    action: "Employee Created",
  },
];
